import type { ChartDataRange } from '@/features/_shared/chart/types/chartData';
import { useSeasonalChartSeries } from '@/features/charts';
import BasicChartBlock from '@/features/markets/components/Chart/BasicChartBlock';
import useInViewport from '@/shared/hooks/useInViewport';
import type { TemplateChartSeries } from '@/shared/types/charts';

type SeasonalChartBlockType = {
  layout?: { fullWidth?: boolean; height?: number };
  templateChartSeries?: TemplateChartSeries[];
  chartDataRange: ChartDataRange;
};
const SeasonalChartBlock = ({
  layout,
  templateChartSeries,
  chartDataRange
}: SeasonalChartBlockType) => {
  const [containerRef, isInViewport] = useInViewport();
  const { loading, error, chartSeries } = useSeasonalChartSeries(
    templateChartSeries,
    chartDataRange,
    isInViewport
  );

  return (
    <BasicChartBlock
      chartSeries={chartSeries}
      chartType='seasonal'
      containerRef={containerRef}
      error={error}
      layout={layout}
      loading={loading}
    />
  );
};

export default SeasonalChartBlock;
